/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const loadingProvisionalConfig = {
  retrieveCredentials: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Retrieving your',
    titleBoldText: 'Provisional policies...',
    description: 'This might take few seconds, Please wait !',
  },
  revokeCredential: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Revoking your',
    titleBoldText: 'Credential...',
    description: 'This might take few seconds, Please wait !',
  },
  credentialListEmpty: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/resting_black.png',
    titleNormalText: 'No Provisional policies found',
    titleBoldText: 'yet',
    description: 'All Purchased provisional polices will display.',
  },
};
